import { GridCellProps } from '@progress/kendo-react-grid';
import styled from 'styled-components';
import { SHToolTip } from 'app/components/SHToolTip';

type Props = {
  className?: string;
  e: GridCellProps;
  onClick?: (e) => void;
  title?: string;
};

const BackNoCell = ({ className, e, onClick, title }: Props) => {
  const data = e?.dataItem;
  return (
    <td className={className ?? ''}>
      <SHToolTip position="top">
        <BackNoWrapper title={data?.backNumber ?? title}>
          {data?.backNumber ?? title}
        </BackNoWrapper>
      </SHToolTip>
    </td>
  );
};

export default BackNoCell;
const BackNoWrapper = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  max-width: 80px;
`;
